import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  technicalTextWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
  headerStyle: {
    fontSize: 20,
    fontWeight: 600,
    paddingBottom: 8,
  },
  borderStyle: {
    padding: 16,
    borderTopWidth: 1,
    borderColor: colors.newUI.therapist.bgBlue10,
  },
  titleFont: {
    fontSize: 42,
    fontWeight: 700,
    color: colors.newUI.therapist.textBlue100,
  },
});
